/* eslint-disable @typescript-eslint/no-unused-vars */
import { api, showErrorNotification, showSuccessNotification } from '@med-fe/util';
import { call, put } from 'redux-saga/effects';
import {
  acceptHooAccommodationFailure,
  acceptHooAccommodationSuccess,
  deleteHooAccommodationFailure,
  deleteHooAccommodationSuccess,
  fetchLocationsForRequestorFailure,
  fetchLocationsForRequestorSuccess,
  fetchRequestorsFailure,
  fetchRequestorsSuccess,
  rejectHooAccommodationFailure,
  rejectHooAccommodationSuccess,
  SaveHooRequestFailed,
  SaveHooRequestSuccess,
  searchHoo,
  searchHooFailed,
  searchHooSuccess,
} from './actions';

export function* searchHooStartWorker({ payload }): Generator {
  try {
    const url = `/schedulechangerequests/search`;
    const data = yield call(api.post, url, payload, null, true, true);
    yield put(searchHooSuccess(data));
  } catch (e) {
    yield put(searchHooFailed(e));
    showErrorNotification();
  }
}

// Fetch requestors by job positions
export function* fetchRequestorsStartWorker(action: any) {
  try {
    const { positions } = action.payload;
    const url = `/employee/by-job-positions?positions=${positions}`;
    const response = yield call(api.get, url, true, true);
    // Unique requestors by ContactSid
    const uniqueRequestors = Array.from(new Map(response.map((item: any) => [item.ContactSid, item])).values()).map(
      (item: any) => ({
        label: item.ContactName,
        value: item.ContactSid,
        contact: item,
      })
    );
    yield put(fetchRequestorsSuccess(uniqueRequestors, response));
  } catch (error) {
    yield put(fetchRequestorsFailure(error));
  }
}

// Fetch locations for selected requestor
export function* fetchLocationsForRequestorStartWorker(action: any) {
  try {
    const { contactSid, allData } = action.payload;
    // Filter locations for selected contactSid
    const locations = allData
      .filter((item: any) => item.ContactSid === contactSid)
      .map((item: any) => ({
        label: `${item.LocationNumber} - ${item.LocationName}`,
        value: item.LocationSid,
      }));
    yield put(fetchLocationsForRequestorSuccess(locations));
  } catch (error) {
    yield put(fetchLocationsForRequestorFailure(error));
  }
}

export function* deleteHooAccommodationStartWorker({ payload }: any): Generator {
  try {
    const { requestId, search } = payload;
    const url = `/schedule-change-requests/${requestId}`;
    const data = yield call(api.put, url, null, null, true, true);
    yield put(searchHoo(search));
    yield put(deleteHooAccommodationSuccess(data));
    showSuccessNotification(data || 'HOO accommodation request canceled successfully.');
  } catch (e: any) {
    yield put(deleteHooAccommodationFailure(e));

    // Extract message safely from Axios error response
    const message =
      e?.response?.data?.error?.messages?.[0] || 'Error while deleting hoo accommodation request. Please try again.';
    showErrorNotification(message);
  }
}

export function* acceptHooAccommodationStartWorker({ payload }: any): Generator {
  try {
    const { requestId, search } = payload;
    const url = `/approve-schedule-change-requests/${requestId}`;
    const data = yield call(api.put, url, null, null, true, true);
    yield put(searchHoo(search));
    yield put(acceptHooAccommodationSuccess(data));
    showSuccessNotification(data || 'HOO accommodation request accepted successfully.');
  } catch (e: any) {
    yield put(acceptHooAccommodationFailure(e));

    // Extract message safely from Axios error response
    const message =
      e?.response?.data?.error?.messages?.[0] || 'Error while accepting hoo accommodation request. Please try again.';
    showErrorNotification(message);
  }
}

export function* rejectHooAccommodationStartWorker({ payload }: any): Generator {
  try {
    const { requestId, search, rejectReason } = payload;
    const url = `/reject-schedule-change-requests/${requestId}`;
    const data = yield call(api.put, url, { RejectReason: rejectReason }, null, true, true);
    yield put(searchHoo(search));
    yield put(rejectHooAccommodationSuccess(data));
    showSuccessNotification(data || 'HOO accommodation request rejected successfully.');
  } catch (e: any) {
    yield put(rejectHooAccommodationFailure(e));
    // Extract message safely from Axios error response
    const message =
      e?.response?.data?.error?.messages?.[0] || 'Error while rejecting hoo accommodation request. Please try again.';
    showErrorNotification(message);
  }
}

export function* saveHooAccommodationStartWorker({ payload }): Generator {
  const { onSuccess, onError, ...dataPayload } = payload;
  try {
    const url = `/schedule-change-requests`;
    const data = yield call(api.post, url, dataPayload, null, true, true);
    yield put(SaveHooRequestSuccess(data));
    showSuccessNotification('Hoo accommodation request saved successfully!');
    if (onSuccess) {
      onSuccess(data);
    }
  } catch (e: any) {
    yield put(SaveHooRequestFailed(e));
    if (onError) {
      onError(e);
    } else {
      // Extract message safely from Axios error response
      const message =
        e?.response?.data?.error?.messages?.[0] || 'Failed to save HOO accommodation request. Please try again.';
      showErrorNotification(message);
    }
  }
}
